import React, {useEffect, useRef, useState} from "react";
import DownloadIcon from "assets/Icon_Btn_02.png";
import FilteredIcon from "../../assets/Icon_File_Filtered.png";
import DropdownArrow from "assets/Icon_Dropdown_Arrow.png";

type ButtonLabel = "Download" | "Export" | "Generate Report";

type DownloadButton = JSX.IntrinsicElements["button"] & {
  options: boolean;
  label: ButtonLabel;
  onClick?(): void;
  onClickFiltered?(): void;
  onClickXlsx?(): void;
};

const DownloadButton: React.FC<DownloadButton> = ({
  options,
  label,
  onClick,
  onClickFiltered,
  onClickXlsx
}) => {
  const [optionsMenuOpen, setOptionsMenuOpen] = useState(false);
  const [optionsMenuVisible, setOptionsMenuVisible] = useState(false); // for fade in effect
  const wrapperRef = useRef(null);

  useEffect(() => {
    if (!optionsMenuOpen) {
      return;
    }
    const clickOutsideListenerFunction = (e: any) =>
      handleClickOutside(e, wrapperRef);
    document.addEventListener("click", clickOutsideListenerFunction);

    return () => {
      document.removeEventListener("click", clickOutsideListenerFunction);
    };
  }, [optionsMenuOpen]);

  const handleOptionsMenuClick = () => {
    if (optionsMenuOpen) {
      setOptionsMenuVisible(false);
      setTimeout(() => {
        setOptionsMenuOpen(false);
      }, 300);
    } else {
      setOptionsMenuOpen(true);
      setTimeout(() => {
        setOptionsMenuVisible(true);
      }, 10);
    }
  };

  const handleClickOutside = (event: any, ref: any) => {
    if (ref.current) {
      if (!ref.current.contains(event.target)) {
        setOptionsMenuVisible(false);
        setTimeout(() => {
          setOptionsMenuOpen(false);
        }, 300);
      }
    }
  };

  const noop = () => {};

  const downloadRaw = onClick ?? noop;

  const downloadFiltered = onClickFiltered ?? noop;

  const downloadXlsx = onClickXlsx ?? noop;

  return (
    <div className="DownloadButton" ref={wrapperRef}>
      <button
        className="Btn BtnDownload"
        onClick={options ? handleOptionsMenuClick : downloadFiltered}
        //onClick={downloadFiltered}
      >
        <div className="BtnDownloadFlex">
          <img src={DownloadIcon} alt="Download" />
          <span>{label}</span>
          {options && (
            <div className="DownloadOptions">
              <img alt="" src={DropdownArrow} style={{ height: "6px" }} />
            </div>
          )}
        </div>
      </button>
      {options && (
        <div
          className={
            optionsMenuOpen
              ? optionsMenuVisible
                ? "Menu Visible"
                : "Menu"
              : "Menu Closed"
          }
        >
          <button className="Option" onClick={downloadXlsx}>
            <div>
              <img src={FilteredIcon} alt="Xlsx" />
            </div>
            <div>xlsx</div>
          </button>
          {/*<button className="Option" onClick={downloadFiltered}>
            <div>
              <img src={FilteredIcon} alt="csv" />
            </div>
            <div>csv</div>
          </button>*/}
        </div>
      )}
    </div>
  );
};

export default DownloadButton;
